import firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAZBjozImiGwlbTYtSesymHqAJ5mE7HMEI",
  authDomain: "pcari-71145.firebaseapp.com",
  databaseURL: "https://pcari-71145.firebaseio.com",
  projectId: "pcari-71145",
  storageBucket: "pcari-71145.appspot.com",
  messagingSenderId: "568647603184",
  appId: "1:568647603184:web:571e2b45a2fb7f122e4335",
  measurementId: "G-SG4WVG00JR",
};

firebase.initializeApp(firebaseConfig);
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const database = firebase.database();
export const isSpported = firebase.messaging.isSupported;
let messaging = null,
  requestFirebaseNotificationPermission = null,
  onMessageListener = null;
if (isSpported()) {
  messaging = firebase.messaging();
  messaging.usePublicVapidKey(
    "BA1ctzldkD-4AVarK3WYHPE91D3r9wSHnHmprLYfr3ZtVPExByH4dHOzF48uwzES_Zx_ZXTySchOYpYghQuimfY"
  );
}

requestFirebaseNotificationPermission = () =>
  new Promise((resolve, reject) => {
    messaging
      .requestPermission()
      .then(() => messaging.getToken())
      .then((firebaseToken) => {
        resolve(firebaseToken);
      })
      .catch((err) => {
        reject(err);
      });
  });

onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export { messaging, requestFirebaseNotificationPermission, onMessageListener };
